var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.$style['app-aside-nav__item']},[_c('a',{directives:[{name:"testid",rawName:"v-testid",value:('nav-item-recar-lite'),expression:"'nav-item-recar-lite'"}],class:[
			_vm.$style['app-aside-nav__link']
		],attrs:{"href":_vm.href,"target":"_blank"}},[_c('BaseIconButton',{class:_vm.$style['app-aside-nav__link-icon']},[_c('img',{staticStyle:{"width":"100%"},attrs:{"withRipple":false,"src":_vm.image,"alt":`${_vm.title}-img`}})]),_vm._v(" "+_vm._s(_vm.title)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }